export default __webpack_public_path__ + "static/media/logoLine.d64974fd.webp";